import type { AppRouteRecordRaw } from "shared/types";
import { LAYOUTS, MODULE_SETTINGS, TEACHER_ROLES } from "shared/constants";
import { STUDENT_MEETING_ROUTE_NAMES } from "./routeNames";

const routes: AppRouteRecordRaw[] = [
  {
    // The leading tab segment mirrors where the meeting was opened from
    // (/my-meetings/open/... or /my-meetings/completed/...); without it the
    // canonical URL still works, which keeps notification links and old
    // bookmarks valid.
    path: "/my-meetings/:tab(open|completed)?/student-meeting/:id",
    name: STUDENT_MEETING_ROUTE_NAMES.MY_MEETING,
    component: () =>
      import("meetings/student-meeting/pages/teacher/TeacherStudentMeetingPage.vue"),
    meta: {
      title: "Mijn bespreking",
      layout: LAYOUTS.MAIN_NO_WRAPPER,
      roleRequired: TEACHER_ROLES,
      settingRequired: [MODULE_SETTINGS.STUDENT_MEETING],
      hideSubmenu: true,
      hideTitle: true,
      exactRouteIdentifier: "myMeetings",
    },
  },
  {
    // Legacy URL from before the /meeting -> /student-meeting rename.
    path: "/my-meetings/meeting/:id",
    redirect: (to) => ({
      name: STUDENT_MEETING_ROUTE_NAMES.MY_MEETING,
      params: { id: to.params.id },
    }),
  },
];

export default routes;
